import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-column-guide/jb-column-guide.scss?inline
var jb_column_guide_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  inset: 0;
  pointer-events: none;
  position: fixed;
  z-index: 1000;
  --_currentcolor: 0, 0, 0;
}

.wrapper {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  height: 100%;
  inset: 0;
  margin-inline: auto;
  padding-right: var(--compensate-scrollbar, 0);
  width: calc(100% - 2 * 6.68%);
}
@media (min-width: 600px) {
  .wrapper {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 960px) {
  .wrapper {
    grid-template-columns: repeat(12, 1fr);
    width: calc(100% - 2 * 6.68%);
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  .wrapper {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 1437px) {
  .wrapper {
    max-width: 1436px;
    width: 100%;
  }
}
.wrapper > div {
  background-color: rgba(var(--_currentcolor), 0.3);
  border: 1px solid rgba(var(--_currentcolor), 1);
  color: white;
  display: grid;
  font-family: sans-serif;
  font-size: 1.5rem;
  font-weight: bold;
  height: 100%;
  place-content: center;
  position: relative;
  -webkit-text-stroke: 1px rgba(var(--_currentcolor), 0.6);
  width: 100%;
}
.wrapper > div:nth-child(7), .wrapper > div:nth-child(8), .wrapper > div:nth-child(9), .wrapper > div:nth-child(10), .wrapper > div:nth-child(11), .wrapper > div:nth-child(12) {
  display: none;
}
@media (min-width: 960px) {
  .wrapper > div:nth-child(7), .wrapper > div:nth-child(8), .wrapper > div:nth-child(9), .wrapper > div:nth-child(10), .wrapper > div:nth-child(11), .wrapper > div:nth-child(12) {
    display: grid;
  }
}
.wrapper > div::before, .wrapper > div::after {
  background-color: rgba(var(--_currentcolor), 0.4);
  content: "";
  height: 100%;
  position: absolute;
  width: 8px;
}
@media (min-width: 960px) {
  .wrapper > div::before, .wrapper > div::after {
    width: 20px;
  }
}
.wrapper > div::before {
  left: 0;
}
.wrapper > div::after {
  right: 0;
}
.wrapper.precision > div {
  background-image: repeating-linear-gradient(to right, rgba(var(--_currentcolor), 0.6) 0, transparent 1px, transparent 9px);
}
.wrapper.white {
  --_currentcolor: 255, 255, 255;
}
.wrapper.red {
  --_currentcolor: 255, 0, 0;
}
.wrapper.green {
  --_currentcolor: 0, 255, 0;
}`;

// src/components/jb-column-guide/jb-column-guide.ts
var JbColumnGuide = class extends h {
  constructor() {
    super(...arguments);
    this.active = false;
    this.colors = ["black", "white", "red", "green"];
    this.precision = false;
    this._currentColor = 0;
  }
  // Save the current state to local storage upon update
  updated(changedProperties) {
    super.updated(changedProperties);
    if (this._currentColor !== void 0 && changedProperties.has("_currentColor")) {
      window.localStorage.setItem("columnGuideCurrentColor", this._currentColor + "");
    }
    if (this.active !== void 0 && changedProperties.has("active")) {
      window.localStorage.setItem("columnGuideActiveState", this.active ? "on" : "off");
    }
    if (this.precision !== void 0 && changedProperties.has("precision")) {
      window.localStorage.setItem("columnGuidePrecisionState", this.precision ? "on" : "off");
    }
  }
  createRenderRoot() {
    return document.body;
  }
  firstUpdated() {
    const savedColor = window.localStorage.getItem("columnGuideCurrentColor");
    if (savedColor) {
      this._currentColor = parseInt(savedColor, 10);
    }
    const savedActive = window.localStorage.getItem("columnGuideActiveState");
    if (savedActive) {
      this.active = savedActive === "on";
    }
    const savedPrecision = window.localStorage.getItem("columnGuidePrecisionState");
    if (savedPrecision) {
      this.precision = savedPrecision === "on";
    }
    console.log(
      "%c!!! JB Column Guide active on Webpage !!!",
      "color: white; background-color: tomato; font-size: 1.5rem;"
    );
    console.log("Usage:");
    console.log("[alt] + [shift] + C: Toggle Column Guide");
    console.log("[alt] + [shift] + I: Cycle color");
    console.log("[alt] + [shift] + P: Toggle precision display");
    window.addEventListener("keydown", (event) => {
      if (event.shiftKey && event.altKey) {
        if (event.code === "KeyC") {
          this.active = !this.active;
        }
        if (event.code === "KeyP") {
          this.precision = !this.precision;
        }
        if (event.code === "KeyI") {
          if (this._currentColor === this.colors.length - 1) {
            this._currentColor = 0;
          } else {
            this._currentColor += 1;
          }
        }
      }
    });
  }
  render() {
    return ke`${this.active ? ke`<jb-column-guide-content
          ?precision=${this.precision}
          .color=${this.colors[this._currentColor]}
        ></jb-column-guide-content>` : D}`;
  }
};
__decorateClass([
  n({ type: Boolean })
], JbColumnGuide.prototype, "active", 2);
__decorateClass([
  n({ type: Array })
], JbColumnGuide.prototype, "colors", 2);
__decorateClass([
  n({ type: Boolean })
], JbColumnGuide.prototype, "precision", 2);
__decorateClass([
  r2()
], JbColumnGuide.prototype, "_currentColor", 2);
JbColumnGuide = __decorateClass([
  customElement("jb-column-guide")
], JbColumnGuide);
var JbColumnGuideContent = class extends h {
  constructor() {
    super(...arguments);
    this.precision = false;
  }
  render() {
    return ke`
      <div class="${Rt({ wrapper: true, precision: this.precision, [`${this.color}`]: true })}">
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>10</div>
        <div>11</div>
        <div>12</div>
      </div>
    `;
  }
};
JbColumnGuideContent.styles = r(jb_column_guide_default);
__decorateClass([
  n()
], JbColumnGuideContent.prototype, "color", 2);
__decorateClass([
  n({ type: Boolean })
], JbColumnGuideContent.prototype, "precision", 2);
JbColumnGuideContent = __decorateClass([
  customElement("jb-column-guide-content")
], JbColumnGuideContent);

export {
  JbColumnGuide,
  JbColumnGuideContent
};
